// import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
// import { message } from 'antd';
// import { staff_projects, staff_users, assign_project } from './api';

// const initialState = {
//   loading: false,
//   staffingStats: null,
//   projects: [],
//   users: [],
//   assignSuccess: false,
//   deleteSuccess: false
// };

// const actions = {
//   GET_STAFFING_DATA: 'staffing/GET_STAFFING_DATA',
//   GET_STAFFING_USERS: 'staffing/GET_STAFFING_USERS',
//   ASSIGN_PROJECT: 'staffing/ASSIGN_PROJECT',
//   DELETE_ASSIGNMENT: 'staffing/DELETE_ASSIGNMENT',
//   UPDATE_ASSIGNMENT: 'staffing/UPDATE_ASSIGNMENT'
// };

// // Fetch staffing project data
// export const fetchStaffingData = createAsyncThunk(
//   actions.GET_STAFFING_DATA,
//   async (payload) => {
//     const response = await staff_projects('get-staffing-projects', payload);
//     console.log('Project Response:', response);
//     return response;
//   }
// );

// // Fetch staffing users
// export const fetchStaffingUsers = createAsyncThunk(
//   actions.GET_STAFFING_USERS,
//   async (payload) => {
//     const response = await staff_users('get-staffing-users', payload);
//     console.log('Users Response:', response);
//     return response;
//   }
// );

// // Assign a project to a user
// export const assignProjectToUser = createAsyncThunk(
//   actions.ASSIGN_PROJECT,
//   async (payload) => {
//     const response = await assign_project('create-staff-assignment', payload);
//     console.log('Assign Response:', response);
//     return response;
//   }
// );

// // delete user form project
// export const deleteStaffAssignment = createAsyncThunk(
//   'staffing/DELETE_ASSIGNMENT',
//   async (payload) => {
//     // payload: { id: 4, type: "delete" }
//     const response = await assign_project('create-staff-assignment', payload);
//     console.log('Delete Response:', response);
//     return response;
//   }
// );

// // Update user assignment
// export const updateStaffAssignment = createAsyncThunk(
//   actions.UPDATE_ASSIGNMENT,
//   async (payload) => {
//     const response = await assign_project('create-staff-assignment', payload); // Same API endpoint
//     console.log('Update Response:', response);
//     return response;
//   }
// );

// export const staffingSlice = createSlice({
//   name: 'projectStaffing',
//   initialState,
//   reducers: {
//     resetAssignSuccess: (state) => {
//       state.assignSuccess = false;
//     },
//     resetDeleteSuccess: (state) => {
//       state.deleteSuccess = false;
//     }
//   },
//   extraReducers: (builder) => {
//     builder
//       // Fetch Projects
//       .addCase(fetchStaffingData.pending, (state) => {
//         state.loading = true;
//       })
//       .addCase(fetchStaffingData.fulfilled, (state, action) => {
//         state.loading = false;
//         const { success, message: msg, data } = action.payload;
//         if (success) {
//           state.projects = data;
//         } else {
//           message.error(msg || 'Failed to fetch project data');
//         }
//       })
//       .addCase(fetchStaffingData.rejected, (state, action) => {
//         state.loading = false;
//         message.error(
//           action.error?.message ||
//             'Something went wrong while fetching project data'
//         );
//       })

//       // Fetch Users
//       .addCase(fetchStaffingUsers.pending, (state) => {
//         state.loading = true;
//       })
//       .addCase(fetchStaffingUsers.fulfilled, (state, action) => {
//         state.loading = false;
//         const { success, message: msg, data } = action.payload;
//         if (success) {
//           state.users = data;
//         } else {
//           message.error(msg || 'Failed to fetch user data');
//         }
//       })
//       .addCase(fetchStaffingUsers.rejected, (state, action) => {
//         state.loading = false;
//         message.error(
//           action.error?.message ||
//             'Something went wrong while fetching user data'
//         );
//       })

//       // Assign Project
//       .addCase(assignProjectToUser.pending, (state) => {
//         state.loading = true;
//       })
//       .addCase(assignProjectToUser.fulfilled, (state, action) => {
//         state.loading = false;
//         const { success, message: msg } = action.payload;
//         if (success) {
//           state.assignSuccess = true;
//           message.success(msg || 'Project assigned successfully');
//         } else {
//           message.error(msg || 'Failed to assign project');
//         }
//       })
//       .addCase(assignProjectToUser.rejected, (state, action) => {
//         state.loading = false;
//         message.error(
//           action.error?.message ||
//             'Something went wrong while assigning project'
//         );
//       })

//       //delete project
//       // Delete Assignment
//       .addCase(deleteStaffAssignment.pending, (state) => {
//         state.loading = true;
//       })
//       .addCase(deleteStaffAssignment.fulfilled, (state, action) => {
//         state.loading = false;
//         const { success, message: msg } = action.payload;
//         if (success) {
//           state.deleteSuccess = true;
//           message.success(msg || 'Assignment deleted successfully');
//         } else {
//           message.error(msg || 'Failed to delete assignment');
//         }
//       })
//       .addCase(deleteStaffAssignment.rejected, (state, action) => {
//         state.loading = false;
//         message.error(
//           action.error?.message ||
//             'Something went wrong while deleting assignment'
//         );
//       })
//       // Update Assignment
//       .addCase(updateStaffAssignment.pending, (state) => {
//         state.loading = true;
//       })
//       .addCase(updateStaffAssignment.fulfilled, (state, action) => {
//         state.loading = false;
//         const { success, message: msg } = action.payload;
//         if (success) {
//           message.success(msg || 'Assignment updated successfully');
//         } else {
//           message.error(msg || 'Failed to update assignment');
//         }
//       })
//       .addCase(updateStaffAssignment.rejected, (state, action) => {
//         state.loading = false;
//         message.error(
//           action.error?.message ||
//             'Something went wrong while updating assignment'
//         );
//       });
//   }
// });

// export const selectStaffingSlice = (state) => state.projectStaffing;
// export const { resetAssignSuccess } = staffingSlice.actions;

// export default staffingSlice.reducer;

import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { message } from 'antd';
import { staff_projects, staff_users, assign_project, user_roles } from './api';

const initialState = {
  loading: false,
  staffingStats: null,
  count: 0,
  projects: [],
  users: [],
  roles: [], // ✅ Added to store user roles
  assignSuccess: false,
  deleteSuccess: false
};

const actions = {
  GET_STAFFING_DATA: 'staffing/GET_STAFFING_DATA',
  GET_STAFFING_USERS: 'staffing/GET_STAFFING_USERS',
  ASSIGN_PROJECT: 'staffing/ASSIGN_PROJECT',
  DELETE_ASSIGNMENT: 'staffing/DELETE_ASSIGNMENT',
  UPDATE_ASSIGNMENT: 'staffing/UPDATE_ASSIGNMENT',
  GET_USER_ROLES: 'staffing/GET_USER_ROLES'
};

// ✅ Fetch user roles
export const fetchUserRoles = createAsyncThunk(
  actions.GET_USER_ROLES,
  async (payload) => {
    const response = await user_roles('get-project-roles', payload);
    console.log('User Roles Response:', response);
    return response;
  }
);

// Fetch staffing project data
export const fetchStaffingData = createAsyncThunk(
  actions.GET_STAFFING_DATA,
  async (payload) => {
    const response = await staff_projects('get-staffing-projects', payload);
    console.log('Project Response:', response);
    return response;
  }
);

// Fetch staffing users
export const fetchStaffingUsers = createAsyncThunk(
  actions.GET_STAFFING_USERS,
  async (payload) => {
    const response = await staff_users('get-staffing-users', payload);
    console.log('Users Response:', response);
    return response;
  }
);

// Assign a project to a user
export const assignProjectToUser = createAsyncThunk(
  actions.ASSIGN_PROJECT,
  async (payload) => {
    const response = await assign_project('create-staff-assignment', payload);
    console.log('Assign Response:', response);
    return response;
  }
);

// Delete assignment
export const deleteStaffAssignment = createAsyncThunk(
  actions.DELETE_ASSIGNMENT,
  async (payload) => {
    const response = await assign_project('create-staff-assignment', payload);
    console.log('Delete Response:', response);
    return response;
  }
);

// Update assignment
export const updateStaffAssignment = createAsyncThunk(
  actions.UPDATE_ASSIGNMENT,
  async (payload) => {
    const response = await assign_project('create-staff-assignment', payload);
    console.log('Update Response:', response);
    return response;
  }
);

export const staffingSlice = createSlice({
  name: 'projectStaffing',
  initialState,
  reducers: {
    resetAssignSuccess: (state) => {
      state.assignSuccess = false;
    },
    resetDeleteSuccess: (state) => {
      state.deleteSuccess = false;
    }
  },
  extraReducers: (builder) => {
    builder

      .addCase(fetchUserRoles.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchUserRoles.fulfilled, (state, action) => {
        state.loading = false;
        const { success, message: msg, data } = action.payload;
        if (success) {
          state.roles = data;
        } else {
          message.error(msg || 'Failed to fetch user roles');
        }
      })
      .addCase(fetchUserRoles.rejected, (state, action) => {
        state.loading = false;
        message.error(
          action.error?.message ||
            'Something went wrong while fetching user roles'
        );
      })

      // Fetch Projects
      .addCase(fetchStaffingData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchStaffingData.fulfilled, (state, action) => {
        state.loading = false;
        const { success, message: msg, data, count } = action.payload;
        if (success) {
          state.projects = data;
          state.count = count;
        } else {
          message.error(msg || 'Failed to fetch project data');
        }
      })
      .addCase(fetchStaffingData.rejected, (state, action) => {
        state.loading = false;
        message.error(
          action.error?.message ||
            'Something went wrong while fetching project data'
        );
      })

      // Fetch Users
      .addCase(fetchStaffingUsers.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchStaffingUsers.fulfilled, (state, action) => {
        state.loading = false;
        const { success, message: msg, data } = action.payload;
        if (success) {
          state.users = data;
        } else {
          message.error(msg || 'Failed to fetch user data');
        }
      })
      .addCase(fetchStaffingUsers.rejected, (state, action) => {
        state.loading = false;
        message.error(
          action.error?.message ||
            'Something went wrong while fetching user data'
        );
      })

      // Assign Project
      .addCase(assignProjectToUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(assignProjectToUser.fulfilled, (state, action) => {
        state.loading = false;
        const { success, message: msg } = action.payload;
        if (success) {
          state.assignSuccess = true;
          message.success(msg || 'Project assigned successfully');
        } else {
          message.error(msg || 'Failed to assign project');
        }
      })
      .addCase(assignProjectToUser.rejected, (state, action) => {
        state.loading = false;
        message.error(
          action.error?.message ||
            'Something went wrong while assigning project'
        );
      })

      // Delete Assignment
      .addCase(deleteStaffAssignment.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteStaffAssignment.fulfilled, (state, action) => {
        state.loading = false;
        const { success, message: msg } = action.payload;
        if (success) {
          state.deleteSuccess = true;
          message.success(msg || 'Assignment deleted successfully');
        } else {
          message.error(msg || 'Failed to delete assignment');
        }
      })
      .addCase(deleteStaffAssignment.rejected, (state, action) => {
        state.loading = false;
        message.error(
          action.error?.message ||
            'Something went wrong while deleting assignment'
        );
      })

      // Update Assignment
      .addCase(updateStaffAssignment.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateStaffAssignment.fulfilled, (state, action) => {
        state.loading = false;
        const { success, message: msg } = action.payload;
        if (success) {
          message.success(msg || 'Assignment updated successfully');
        } else {
          message.error(msg || 'Failed to update assignment');
        }
      })
      .addCase(updateStaffAssignment.rejected, (state, action) => {
        state.loading = false;
        message.error(
          action.error?.message ||
            'Something went wrong while updating assignment'
        );
      });
  }
});

export const selectStaffingSlice = (state) => state.projectStaffing;
export const { resetAssignSuccess, resetDeleteSuccess } = staffingSlice.actions;
export default staffingSlice.reducer;
